import React, { useState, useEffect } from 'react';
import { Observer } from 'mobx-react';
import { css } from '@emotion/core';
import { toJS } from 'mobx';
import moment from 'moment';
import NotificationsIcon from '@material-ui/icons/Notifications';
import WarningTwoToneIcon from '@material-ui/icons/WarningTwoTone';
import FlagRoundedIcon from '@material-ui/icons/FlagRounded';
import SettingsRoundedIcon from '@material-ui/icons/SettingsRounded';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import PriorityHighRoundedIcon from '@material-ui/icons/PriorityHighRounded';
import NotificationsNoneTwoToneIcon from '@material-ui/icons/NotificationsNoneTwoTone';
import {
  Typography,
  IconButton,
  Badge,
  Menu,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useRootStore } from '../stores/BridgeProvider';

// *********** Start Of Notification Component *****************
const Notification = ({
  notificationTypes,
  notification,
  dismissNotice,
  truncateString,
}) => {
  const [open, setOpen] = useState(false);
  const { CreatedTimestamp } = notification;

  const mformat = moment
    .utc(CreatedTimestamp)
    .local()
    .format('MM/DD/YY, hh:mm:ss A');

  const openNotification = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const NotificationWrapper = css`
    width: 400px;
    max-width: 400px;
    margin: auto 0;
    .notification-container {
      display: flex;
      padding: 8px;
      align-items: center;
    }
    .notification-icon {
      margin-right: 5px;
    }
    .notification-content {
      width: 100%;
      color: #6f6f6f;
    }
    .subject-block {
      font-size: 0.9rem;
      cursor: pointer;
    }
    .notification-footer {
      margin-top: 5px;
      display: flex;
      justify-content: space-between;
      font-size: 0.8rem;
    }
    .unread {
      color: black;
      font-weight: 600;
    }
    .dismiss-btn {
      cursor: pointer;
    }
  `;
  return (
    <div css={NotificationWrapper}>
      <Divider />
      <div className="notification-container">
        <div className="notification-icon">
          {notificationTypes.find(val => val.Type === notification.Type).icon}
        </div>
        <div
          className={`notification-content ${!notification.IsRead && 'unread'}`}
        >
          <div className="subject-block" onClick={openNotification}>
            {truncateString(notification.Subject, 80)}
          </div>
          <div className="notification-footer">
            <div className="time-stamp">
              {moment.utc(CreatedTimestamp).fromNow()}
            </div>{' '}
            <span
              className="dismiss-btn"
              onClick={() => dismissNotice(notification.NotificationId)}
            >
              Dismiss
            </span>
          </div>
        </div>
      </div>
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        {' '}
        <DialogTitle>{notification.Title}</DialogTitle>
        <DialogContent>
          <div style={{ paddingBottom: '16px' }}>
            <p>{notification.Body} </p>
            {notification.Title === 'Organization Setup Incomplete' && (
              <p>
                <Link
                  onClick={() => handleClose()}
                  style={{ color: 'blue' }}
                  to="/dashboard"
                >
                  {' '}
                  setup tasks.
                </Link>
              </p>
            )}
            {notification.Subject === 'You have been invited' && (
              <p>
                <Link
                  onClick={() => handleClose()}
                  style={{ color: 'blue' }}
                  to={{
                    pathname: '/select-organization',
                    state: {
                      currentTab: 'org-invitations',
                    },
                  }}
                >
                  {' '}
                  View Invitations
                </Link>
              </p>
            )}
            <p
              style={{
                fontSize: '0.6rem',
                marginTop: '3rem',
                color: '#6f6f6f',
              }}
            >
              Created: {mformat}
            </p>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
// **************** End of Notification Component *************

// **************** Start of News Feed (notification tray) **********

export function NewsFeed() {
  const { authStore } = useRootStore();
  const { notifications } = authStore;
  const [newsFeed, setNewsFeed] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const newNotifications = newsFeed.some(notice => !notice.IsRead);

  useEffect(() => {
    if (notifications) {
      setNewsFeed(notifications);
    }
  }, [notifications]);
  const handleMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const markAllRead = async () => {
    try {
      await authStore.request.post(
        `${process.env.REACT_APP_API}/api/mark-notifications-read`,
      );
    } catch (e) {
      console.log(e);
    }
  };
  const handleClose = async () => {
    setAnchorEl(null);
    newNotifications && markAllRead();
  };

  const notificationTypes = [
    {
      Type: 'Error',
      icon: <WarningTwoToneIcon color="error" fontSize="large" />,
    },
    {
      Type: 'Warning',
      icon: <PriorityHighRoundedIcon htmlColor="#f2c40e" fontSize="large" />,
    },
    {
      Type: 'Success',
      icon: <CheckCircleRoundedIcon htmlColor="#4aa54e" fontSize="large" />,
    },
    {
      Type: 'Systems',
      icon: <SettingsRoundedIcon htmlColor="#6f6f6f" fontSize="large" />,
    },
    {
      Type: 'Task',
      icon: <FlagRoundedIcon htmlColor="#01a1e7" fontSize="large" />,
    },
  ];
  const truncateString = (str, num) => {
    if (str.length < num) {
      return str;
    }
    return `${str.slice(0, num)}...`;
  };

  const dismissNotice = async NoticeId => {
    try {
      await authStore.request.delete(
        `${process.env.REACT_APP_API}/api/notification`,
        {
          data: { NotificationId: NoticeId },
        },
      );
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <Observer
      render={() => {
        return (
          <div>
            <IconButton
              color="inherit"
              onClick={handleMenu}
              id="navNotificationIcon"
            >
              {newNotifications ? (
                <Badge color="secondary" variant="dot" overlap="circle">
                  <NotificationsIcon />
                </Badge>
              ) : (
                <NotificationsNoneTwoToneIcon />
              )}
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              getContentAnchorEl={null}
              open={open}
              onClose={handleClose}
            >
              <Typography
                variant="h4"
                style={{
                  padding: '10px 0',
                  textAlign: 'center',
                  minWidth: '400px',
                }}
              >
                Notifications
              </Typography>
              <div
                style={{
                  display: 'flex',
                  flexFlow: 'column-reverse nowrap',
                }}
              >
                {newsFeed.length > 0 ? (
                  newsFeed.map(notification => {
                    return (
                      <Notification
                        notificationTypes={notificationTypes}
                        notification={notification}
                        truncateString={truncateString}
                        dismissNotice={dismissNotice}
                        key={notification.NotificationId}
                      />
                    );
                  })
                ) : (
                  <div>
                    <Divider />
                    <p style={{ color: '#6f6f6f', textAlign: 'center' }}>
                      You have no notifications
                    </p>
                  </div>
                )}
              </div>
            </Menu>
          </div>
        );
      }}
    />
  );
}
// **************** End of News Feed (notification tray) **********
